import React, { useState } from 'react';
import { base44 } from '@/api/base44Client';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Bell, X, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';

export default function JobAlertBar() {
  const [email, setEmail] = useState('');
  const [dismissed, setDismissed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  if (dismissed) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    try {
      // Check if already subscribed
      const existing = await base44.entities.NewsletterSubscriber.filter({ email });
      if (!existing.length) {
        await base44.entities.NewsletterSubscriber.create({
          email,
          source: 'alert_bar',
          is_active: true
        });
      }
      setSubmitted(true);
      toast.success('You\'re subscribed! Job alerts will be sent to your email.');
    } catch (error) {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gradient-to-r from-teal-600 to-cyan-600 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-between gap-4">
          {!submitted ? (
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row items-center gap-3 w-full">
              <div className="flex items-center gap-2 flex-shrink-0">
                <Bell className="h-5 w-5" />
                <span className="text-sm font-medium hidden sm:inline">Get new healthcare jobs in your inbox</span>
                <span className="text-sm font-medium sm:hidden">Get job alerts</span>
              </div>
              <div className="flex gap-2 w-full sm:w-auto sm:ml-auto">
                <Input
                  type="email"
                  required
                  placeholder="your@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="bg-white/95 border-0 text-slate-900 h-9 sm:w-64"
                />
                <Button
                  type="submit"
                  disabled={loading}
                  variant="secondary"
                  className="bg-white text-teal-700 hover:bg-slate-100 h-9"
                >
                  {loading ? '...' : 'Subscribe'}
                </Button>
              </div>
            </form>
          ) : (
            <div className="flex items-center gap-2 py-1">
              <CheckCircle className="h-5 w-5" />
              <span className="text-sm font-medium">You're subscribed! Watch your inbox for new job alerts.</span>
            </div>
          )}
          <button
            onClick={() => setDismissed(true)}
            className="flex-shrink-0 opacity-80 hover:opacity-100"
            aria-label="Dismiss"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}